var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlugHouseholdJMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,12c-2.2060547,0-4,1.7939453-4,4s1.7939453,4,4,4s4-1.7939453,4-4S26.2060547,12,24,12z M24,18 c-1.1025391,0-2-0.8974609-2-2s0.8974609-2,2-2s2,0.8974609,2,2S25.1025391,18,24,18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,28c0,2.2060547,1.7939453,4,4,4s4-1.7939453,4-4s-1.7939453-4-4-4S28,25.7939453,28,28z M34,28 c0,1.1025391-0.8974609,2-2,2s-2-0.8974609-2-2s0.8974609-2,2-2S34,26.8974609,34,28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,24c-2.2060547,0-4,1.7939453-4,4s1.7939453,4,4,4s4-1.7939453,4-4S18.2060547,24,16,24z M16,30 c-1.1025391,0-2-0.8974609-2-2s0.8974609-2,2-2s2,0.8974609,2,2S17.1025391,30,16,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8652344,23.4990234l-11-19C35.6865234,4.1904297,35.3564453,4,35,4H13 c-0.3564453,0-0.6865234,0.1904297-0.8652344,0.4990234l-11,19c-0.1796875,0.3095703-0.1796875,0.6923828,0,1.0019531l11,19 C12.3134766,43.8095703,12.6435547,44,13,44h22c0.3564453,0,0.6865234-0.1904297,0.8652344-0.4990234l11-19 C47.0449219,24.1914062,47.0449219,23.8085938,46.8652344,23.4990234z M34.4238281,42H13.5761719L3.1552734,24L13.5761719,6 h20.8476562l10.4208984,18L34.4238281,42z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugHouseholdJMedium);
export default __webpack_public_path__ + "static/media/plug-household-j--medium.988b1bb562ece99c458418984185ec37.svg";
export { ForwardRef as ReactComponent };